import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../lib";
export class ApiEpSessionDrag {
}
ApiEpSessionDrag.read = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/session-drag/${req.path.token}`,
    method: "GET",
});
//# sourceMappingURL=session_drag.js.map